// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import BundleOrderLine from "./bundle-order-line.js"
import Order from "./order.js"
import OrderLinePhoto from "./order-line-photo.js"
import PhotoSheetProductOrderLine from "./photo-sheet-product-order-line.js"
import Supplier from "./supplier.js"
import Tenant from "./tenant.js"

const modelClassData = {
  "attributes": {
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "order_id": {
      "column": {
        "default": null,
        "name": "order_id",
        "null": false,
        "type": "uuid"
      },
      "name": "order_id",
      "selected_by_default": null,
      "translated": null
    },
    "orderable_id": {
      "column": {
        "default": null,
        "name": "orderable_id",
        "null": false,
        "type": "uuid"
      },
      "name": "orderable_id",
      "selected_by_default": null,
      "translated": null
    },
    "orderable_type": {
      "column": {
        "default": null,
        "name": "orderable_type",
        "null": false,
        "type": "string"
      },
      "name": "orderable_type",
      "selected_by_default": null,
      "translated": null
    },
    "order_line_number": {
      "column": {
        "default": null,
        "name": "order_line_number",
        "null": false,
        "type": "integer"
      },
      "name": "order_line_number",
      "selected_by_default": null,
      "translated": null
    },
    "quantity": {
      "column": {
        "default": 1,
        "name": "quantity",
        "null": false,
        "type": "integer"
      },
      "name": "quantity",
      "selected_by_default": null,
      "translated": null
    },
    "supplier_id": {
      "column": {
        "default": null,
        "name": "supplier_id",
        "null": true,
        "type": "uuid"
      },
      "name": "supplier_id",
      "selected_by_default": null,
      "translated": null
    },
    "total_price": {
      "column": null,
      "name": "total_price",
      "selected_by_default": null,
      "translated": null
    },
    "total_price_with_vat": {
      "column": null,
      "name": "total_price_with_vat",
      "selected_by_default": null,
      "translated": null
    },
    "updated_at": {
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      },
      "name": "updated_at",
      "selected_by_default": null,
      "translated": null
    },
    "orderable": {
      "column": null,
      "name": "orderable",
      "selected_by_default": false,
      "translated": null
    }
  },
  "className": "OrderLine",
  "collectionKey": "order_lines",
  "collectionName": "order_lines",
  "i18nKey": "order_line",
  "camelizedLower": "orderLine",
  "name": "OrderLine",
  "nameDasherized": "order-line",
  "pluralName": "order_lines",
  "ransackable_associations": [
    {
      "className": "BundleOrderLine",
      "collectionName": "bundle_order_lines",
      "foreignKey": "orderable_id",
      "name": "bundle_order_line",
      "macro": "belongs_to",
      "resource_name": "BundleOrderLine",
      "through": null
    },
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "Order",
      "collectionName": "orders",
      "foreignKey": "order_id",
      "name": "order",
      "macro": "belongs_to",
      "resource_name": "Order",
      "through": null
    },
    {
      "className": "OrderLinePhoto",
      "collectionName": "order_line_photos",
      "foreignKey": "orderable_id",
      "name": "order_line_photo",
      "macro": "belongs_to",
      "resource_name": "OrderLinePhoto",
      "through": null
    },
    {
      "className": "Orderable",
      "collectionName": null,
      "foreignKey": "orderable_id",
      "name": "orderable",
      "macro": "belongs_to",
      "resource_name": null,
      "through": null
    },
    {
      "className": "PhotoSheetProductOrderLine",
      "collectionName": "photo_sheet_product_order_lines",
      "foreignKey": "orderable_id",
      "name": "photo_sheet_product_order_line",
      "macro": "belongs_to",
      "resource_name": "PhotoSheetProductOrderLine",
      "through": null
    },
    {
      "className": "Supplier",
      "collectionName": "suppliers",
      "foreignKey": "supplier_id",
      "name": "supplier",
      "macro": "belongs_to",
      "resource_name": "Supplier",
      "through": null
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "order_id",
      "column": {
        "default": null,
        "name": "order_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "order_line_number",
      "column": {
        "default": null,
        "name": "order_line_number",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "orderable_id",
      "column": {
        "default": null,
        "name": "orderable_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "orderable_type",
      "column": {
        "default": null,
        "name": "orderable_type",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "quantity",
      "column": {
        "default": 1,
        "name": "quantity",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "supplier_id",
      "column": {
        "default": null,
        "name": "supplier_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "total_price_cents",
      "column": {
        "default": null,
        "name": "total_price_cents",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "total_price_currency",
      "column": {
        "default": "DKK",
        "name": "total_price_currency",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "total_price_with_vat_cents",
      "column": {
        "default": null,
        "name": "total_price_with_vat_cents",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "total_price_with_vat_currency",
      "column": {
        "default": "DKK",
        "name": "total_price_with_vat_currency",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "unit_price_cents",
      "column": {
        "default": null,
        "name": "unit_price_cents",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "unit_price_currency",
      "column": {
        "default": "DKK",
        "name": "unit_price_currency",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "vat_cents",
      "column": {
        "default": null,
        "name": "vat_cents",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "vat_currency",
      "column": {
        "default": "DKK",
        "name": "vat_currency",
        "null": false,
        "type": "string"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [
    {
      "className": "BundleOrderLine",
      "collectionName": "bundle_order_lines",
      "foreignKey": "orderable_id",
      "name": "bundle_order_line",
      "macro": "belongs_to",
      "resource_name": "BundleOrderLine",
      "through": null
    },
    {
      "className": "Order",
      "collectionName": "orders",
      "foreignKey": "order_id",
      "name": "order",
      "macro": "belongs_to",
      "resource_name": "Order",
      "through": null
    },
    {
      "className": "OrderLinePhoto",
      "collectionName": "order_line_photos",
      "foreignKey": "orderable_id",
      "name": "order_line_photo",
      "macro": "belongs_to",
      "resource_name": "OrderLinePhoto",
      "through": null
    },
    {
      "className": "PhotoSheetProductOrderLine",
      "collectionName": "photo_sheet_product_order_lines",
      "foreignKey": "orderable_id",
      "name": "photo_sheet_product_order_line",
      "macro": "belongs_to",
      "resource_name": "PhotoSheetProductOrderLine",
      "through": null
    },
    {
      "className": "Supplier",
      "collectionName": "suppliers",
      "foreignKey": "supplier_id",
      "name": "supplier",
      "macro": "belongs_to",
      "resource_name": "Supplier",
      "through": null
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    }
  ],
  "paramKey": "order_line",
  "primaryKey": "id"
}

/** Frontend model for OrderLine. */
export default class OrderLine extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {Date} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {string} */
  orderId() {
    return this.readAttributeUnderscore("order_id")
  }

  /** @returns {boolean} */
  hasOrderId() {
    const value = this.orderId()

    return this._isPresent(value)
  }

  /** @returns {string} */
  orderableId() {
    return this.readAttributeUnderscore("orderable_id")
  }

  /** @returns {boolean} */
  hasOrderableId() {
    const value = this.orderableId()

    return this._isPresent(value)
  }

  /** @returns {string} */
  orderableType() {
    return this.readAttributeUnderscore("orderable_type")
  }

  /** @returns {boolean} */
  hasOrderableType() {
    const value = this.orderableType()

    return this._isPresent(value)
  }

  /** @returns {number} */
  orderLineNumber() {
    return this.readAttributeUnderscore("order_line_number")
  }

  /** @returns {boolean} */
  hasOrderLineNumber() {
    const value = this.orderLineNumber()

    return this._isPresent(value)
  }

  /** @returns {number} */
  quantity() {
    return this.readAttributeUnderscore("quantity")
  }

  /** @returns {boolean} */
  hasQuantity() {
    const value = this.quantity()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  supplierId() {
    return this.readAttributeUnderscore("supplier_id")
  }

  /** @returns {boolean} */
  hasSupplierId() {
    const value = this.supplierId()

    return this._isPresent(value)
  }

  /** @returns {any} */
  totalPrice() {
    return this.readAttributeUnderscore("total_price")
  }

  /** @returns {boolean} */
  hasTotalPrice() {
    const value = this.totalPrice()

    return this._isPresent(value)
  }

  /** @returns {any} */
  totalPriceWithVat() {
    return this.readAttributeUnderscore("total_price_with_vat")
  }

  /** @returns {boolean} */
  hasTotalPriceWithVat() {
    const value = this.totalPriceWithVat()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  updatedAt() {
    return this.readAttributeUnderscore("updated_at")
  }

  /** @returns {boolean} */
  hasUpdatedAt() {
    const value = this.updatedAt()

    return this._isPresent(value)
  }

  /** @returns {any} */
  orderable() {
    return this.readAttributeUnderscore("orderable")
  }

  /** @returns {boolean} */
  hasOrderable() {
    const value = this.orderable()

    return this._isPresent(value)
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  static addToBasket(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (BaseModel._callCollectionCommand(
      {
        args,
        command: "add_to_basket",
        collectionName: "order_lines",
        type: "collection"
      },
      commandArgs
    ))
  }

  /** @returns {import("./bundle-order-line.js").default | null} */
  bundleOrderLine() {
    return this._readBelongsToReflection({modelClass: BundleOrderLine, reflectionName: "bundle_order_line"})
  }

  /** @returns {Promise<import("./bundle-order-line.js").default | null>} */
  loadBundleOrderLine() {
    if (!("orderableId" in this)) throw new Error("Foreign key method wasn't defined: orderableId")

    const id = this.orderableId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "bundle_order_line",
        model: this,
        modelClass: BundleOrderLine
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./bundle-order-line.js").default | null>} */
  ensureBundleOrderLineLoaded() {
    return this.ensureAssociationLoaded("bundle_order_line")
  }

  /** @returns {import("./order.js").default | null} */
  order() {
    return this._readBelongsToReflection({modelClass: Order, reflectionName: "order"})
  }

  /** @returns {Promise<import("./order.js").default | null>} */
  loadOrder() {
    if (!("orderId" in this)) throw new Error("Foreign key method wasn't defined: orderId")

    const id = this.orderId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "order",
        model: this,
        modelClass: Order
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./order.js").default | null>} */
  ensureOrderLoaded() {
    return this.ensureAssociationLoaded("order")
  }

  /** @returns {import("./order-line-photo.js").default | null} */
  orderLinePhoto() {
    return this._readBelongsToReflection({modelClass: OrderLinePhoto, reflectionName: "order_line_photo"})
  }

  /** @returns {Promise<import("./order-line-photo.js").default | null>} */
  loadOrderLinePhoto() {
    if (!("orderableId" in this)) throw new Error("Foreign key method wasn't defined: orderableId")

    const id = this.orderableId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "order_line_photo",
        model: this,
        modelClass: OrderLinePhoto
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./order-line-photo.js").default | null>} */
  ensureOrderLinePhotoLoaded() {
    return this.ensureAssociationLoaded("order_line_photo")
  }

  /** @returns {import("./photo-sheet-product-order-line.js").default | null} */
  photoSheetProductOrderLine() {
    return this._readBelongsToReflection({modelClass: PhotoSheetProductOrderLine, reflectionName: "photo_sheet_product_order_line"})
  }

  /** @returns {Promise<import("./photo-sheet-product-order-line.js").default | null>} */
  loadPhotoSheetProductOrderLine() {
    if (!("orderableId" in this)) throw new Error("Foreign key method wasn't defined: orderableId")

    const id = this.orderableId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "photo_sheet_product_order_line",
        model: this,
        modelClass: PhotoSheetProductOrderLine
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./photo-sheet-product-order-line.js").default | null>} */
  ensurePhotoSheetProductOrderLineLoaded() {
    return this.ensureAssociationLoaded("photo_sheet_product_order_line")
  }

  /** @returns {import("./supplier.js").default | null} */
  supplier() {
    return this._readBelongsToReflection({modelClass: Supplier, reflectionName: "supplier"})
  }

  /** @returns {Promise<import("./supplier.js").default | null>} */
  loadSupplier() {
    if (!("supplierId" in this)) throw new Error("Foreign key method wasn't defined: supplierId")

    const id = this.supplierId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "supplier",
        model: this,
        modelClass: Supplier
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./supplier.js").default | null>} */
  ensureSupplierLoaded() {
    return this.ensureAssociationLoaded("supplier")
  }

  /** @returns {import("./tenant.js").default | null} */
  tenant() {
    return this._readBelongsToReflection({modelClass: Tenant, reflectionName: "tenant"})
  }

  /** @returns {Promise<import("./tenant.js").default | null>} */
  loadTenant() {
    if (!("tenantId" in this)) throw new Error("Foreign key method wasn't defined: tenantId")

    const id = this.tenantId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "tenant",
        model: this,
        modelClass: Tenant
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./tenant.js").default | null>} */
  ensureTenantLoaded() {
    return this.ensureAssociationLoaded("tenant")
  }
}
